(function(){
  const weeklyPath=/\/pages\/weekly\/?$/.test(window.location.pathname);
  if(!weeklyPath) return;

  document.addEventListener('DOMContentLoaded',function(){
    const reviewStep=document.getElementById('sb-s5');
    const deliveryStep=document.getElementById('sb-s4');
    if(!reviewStep || !deliveryStep || typeof window.goStep!=='function') return;

    const originalGoStep=window.goStep;
    const originalTryGoStep5=window.tryGoStep5;
    const originalStartPlan=window.startPlan;
    const originalUpdateUpsellSummary=window.updateUpsellSummary;

    const qaStyle=document.createElement('style');
    qaStyle.textContent=[
      '.sk-qa-contact{margin:0 0 8px}',
      '.sk-qa-sms{display:flex;gap:10px;align-items:flex-start;margin:4px 0 26px;padding:14px 16px;border:1px solid #e8e2da;border-radius:12px;background:#faf7f5;color:#555;font-size:.78rem;line-height:1.5}',
      '.sk-qa-sms input{margin-top:2px;accent-color:#b85c2a}',
      '.sk-qa-sms strong{display:block;color:#1c1c1c;margin-bottom:2px}',
      '.sk-qa-addons-note{font-size:.75rem;font-weight:400;color:#888;margin-top:4px}',
      '.sk-qa-contact-note{font-size:.76rem;color:#888;margin:-18px 0 24px;line-height:1.5}',
      '.sk-qa-required-error{border-color:#c0392b!important;box-shadow:0 0 0 2px rgba(192,57,43,.08)}'
    ].join('');
    document.head.appendChild(qaStyle);

    function setLogicalProgress(step){
      const labels=document.querySelectorAll('.sb-prog-label');
      if(labels[3]) labels[3].textContent='Review';
      if(labels[4]) labels[4].textContent='Delivery';
      document.querySelectorAll('.sb-prog-dot').forEach(function(dot,index){
        const n=parseInt(dot.dataset.step || String(index+1),10);
        dot.classList.toggle('done',n<step);
        dot.classList.toggle('active',n===step);
      });
      document.querySelectorAll('.sb-prog-line').forEach(function(line,index){
        const n=parseInt(line.dataset.line || String(index+1),10);
        line.classList.toggle('done',n<step);
      });
      labels.forEach(function(label,index){
        const n=index+1;
        label.classList.toggle('done',n<step);
        label.classList.toggle('active',n===step);
      });
    }

    function logicalStepFromDom(){
      if(reviewStep.classList.contains('active')) return 4;
      if(deliveryStep.classList.contains('active')) return 5;
      for(let n=1;n<=3;n+=1){
        const el=document.getElementById('sb-s'+n);
        if(el && el.classList.contains('active')) return n;
      }
      return 1;
    }

    function hideReviewDelivery(){
      const delivery=document.getElementById('rv-delivery');
      const section=delivery && delivery.closest('.sb-review-section');
      if(section) section.style.display='none';
    }

    function polishReview(){
      const heading=reviewStep.querySelector('.sb-step-heading');
      const sub=reviewStep.querySelector('.sb-step-sub');
      if(heading) heading.innerHTML='Your <em>plan is ready!</em>';
      if(sub) sub.textContent='Review your meals and add anything extra before entering your delivery details.';
      const planName=document.getElementById('rv-plan-name');
      if(planName) planName.innerHTML=planName.innerHTML.replace(/\bBox\b/g,'Plan');
      const estimate=document.getElementById('rv-estimated-total');
      if(estimate && /box subtotal/i.test(estimate.textContent || '')) estimate.textContent=estimate.textContent.replace(/box subtotal/ig,'plan subtotal');
      hideReviewDelivery();
      const upsellList=document.getElementById('sb-upsell-list');
      const upsellCard=upsellList && upsellList.parentElement;
      const upsellHeading=upsellCard && upsellCard.firstElementChild;
      if(upsellHeading && /Enhance Your Box/i.test(upsellHeading.textContent || '')){
        upsellHeading.innerHTML='Add Something Extra <span style="font-size:.75rem;font-weight:400;color:#888;">(optional)</span><div class="sk-qa-addons-note">Breakfast, snacks, desserts, and proteins by the pound.</div>';
      }
    }

    function buildContactFields(){
      if(document.getElementById('qa-contact-fields')) return;
      const firstDeliveryRow=deliveryStep.querySelector('.sb-form-row');
      if(!firstDeliveryRow) return;
      const wrap=document.createElement('div');
      wrap.id='qa-contact-fields';
      wrap.className='sk-qa-contact';
      wrap.innerHTML=
        '<div class="sb-form-row">'
        + '<div class="sb-field"><label class="sb-label" for="qa-first-name">First Name</label><input class="sb-input" id="qa-first-name" type="text" autocomplete="given-name" placeholder="First name"></div>'
        + '<div class="sb-field"><label class="sb-label" for="qa-last-name">Last Name</label><input class="sb-input" id="qa-last-name" type="text" autocomplete="family-name" placeholder="Last name"></div>'
        + '</div>'
        + '<div class="sb-form-row">'
        + '<div class="sb-field"><label class="sb-label" for="qa-email">Email</label><input class="sb-input" id="qa-email" type="email" autocomplete="email" inputmode="email" placeholder="you@example.com"></div>'
        + '<div class="sb-field"><label class="sb-label" for="qa-phone">Mobile Phone</label><input class="sb-input" id="qa-phone" type="tel" autocomplete="tel" inputmode="tel" placeholder="(702) 555-0123"></div>'
        + '</div>'
        + '<p class="sk-qa-contact-note">We’ll carry your email, name, and delivery address into secure checkout so you don’t have to enter them again.</p>'
        + '<label class="sk-qa-sms" for="qa-sms-optin"><input id="qa-sms-optin" type="checkbox"><span><strong>Text me weekly meal-selection reminders and occasional SmoKeto updates.</strong>Optional. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.</span></label>';
      deliveryStep.insertBefore(wrap,firstDeliveryRow);
    }

    function readContact(){
      const get=function(id){ const el=document.getElementById(id); return el ? el.value.trim() : ''; };
      return {first:get('qa-first-name'),last:get('qa-last-name'),email:get('qa-email'),phone:get('qa-phone'),sms:!!(document.getElementById('qa-sms-optin') && document.getElementById('qa-sms-optin').checked)};
    }

    function restoreContact(){
      let saved={};
      try{ saved=JSON.parse(localStorage.getItem('sk_contact') || '{}') || {}; }catch(e){}
      let gateEmail='';
      try{ gateEmail=sessionStorage.getItem('sk_session_email') || ''; }catch(e){}
      const values={'qa-first-name':saved.first || '','qa-last-name':saved.last || '','qa-email':saved.email || gateEmail,'qa-phone':saved.phone || ''};
      Object.keys(values).forEach(function(id){ const el=document.getElementById(id); if(el && !el.value) el.value=values[id]; });
      const sms=document.getElementById('qa-sms-optin');
      if(sms && saved.sms) sms.checked=true;
    }

    function validateContact(contact){
      const ids=['qa-first-name','qa-last-name','qa-email','qa-phone'];
      ids.forEach(function(id){ const el=document.getElementById(id); if(el) el.classList.remove('sk-qa-required-error'); });
      const missing=[];
      if(!contact.first) missing.push('qa-first-name');
      if(!contact.last) missing.push('qa-last-name');
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact.email)) missing.push('qa-email');
      if(contact.phone.replace(/\D/g,'').length<10) missing.push('qa-phone');
      if(missing.length){
        missing.forEach(function(id){ const el=document.getElementById(id); if(el) el.classList.add('sk-qa-required-error'); });
        const first=document.getElementById(missing[0]);
        if(first){ first.focus(); first.scrollIntoView({behavior:'smooth',block:'center'}); }
        window.alert('Please complete your name, email, and mobile phone before continuing.');
        return false;
      }
      return true;
    }

    function installCheckoutHooks(contact){
      window.__skQaCheckoutContact=contact;
      if(!window.__skQaNativeFetch){
        window.__skQaNativeFetch=window.fetch.bind(window);
        window.fetch=function(input,init){
          const nativeFetch=window.__skQaNativeFetch;
          let url='';
          try{ url=typeof input==='string' ? input : (input && input.url) || ''; }catch(e){}
          if(url.indexOf('/cart/update.js')!==-1 && init && init.body){
            try{
              const payload=JSON.parse(init.body);
              const c=window.__skQaCheckoutContact || {};
              payload.attributes=Object.assign({},payload.attributes || {},{__contact_first_name:c.first || '',__contact_last_name:c.last || '',__contact_email:c.email || '',__contact_phone:c.phone || '',__sms_opt_in:c.sms ? 'yes' : 'no'});
              if(c.sms) payload.attributes.__sms_opt_in_at=new Date().toISOString();
              init=Object.assign({},init,{body:JSON.stringify(payload)});
            }catch(e){}
          }
          return nativeFetch(input,init);
        };
      }
      const proto=window.URLSearchParams && window.URLSearchParams.prototype;
      if(proto && !proto.__skQaNativeToString){
        proto.__skQaNativeToString=proto.toString;
        proto.toString=function(){
          const c=window.__skQaCheckoutContact || {};
          if(this.has('checkout[email]')){
            const val=function(id){ const el=document.getElementById(id); return el ? el.value.trim() : ''; };
            const setIf=function(key,value){ if(value) this.set(key,value); }.bind(this);
            setIf('checkout[email]',c.email);
            setIf('checkout[shipping_address][first_name]',c.first);
            setIf('checkout[shipping_address][last_name]',c.last);
            setIf('checkout[shipping_address][address1]',val('d-addr1'));
            setIf('checkout[shipping_address][address2]',val('d-addr2'));
            setIf('checkout[shipping_address][city]',val('d-city'));
            setIf('checkout[shipping_address][province]','Nevada');
            setIf('checkout[shipping_address][country]','United States');
            setIf('checkout[shipping_address][zip]',val('d-zip'));
          }
          return proto.__skQaNativeToString.apply(this,arguments);
        };
      }
    }

    function moveFinalConfirmation(){
      const allergen=reviewStep.querySelector('.sb-allergen-ack');
      const checkout=document.getElementById('sb-start-btn');
      const fine=reviewStep.querySelector('.sb-fine-print');
      const nav=deliveryStep.querySelector('.sb-nav-row');
      if(!nav) return;
      if(allergen) deliveryStep.insertBefore(allergen,nav);
      if(checkout){ checkout.onclick=null; checkout.setAttribute('onclick','qaFinishCheckout()'); deliveryStep.insertBefore(checkout,nav); }
      if(fine) deliveryStep.insertBefore(fine,nav);
    }

    function prepareNavigation(){
      const reviewNav=reviewStep.querySelector('.sb-nav-row');
      if(reviewNav){
        const back=reviewNav.querySelector('.sb-btn-back');
        if(back){ back.removeAttribute('onclick'); back.onclick=function(){ window.goStep(3); }; }
        let next=document.getElementById('qa-review-next');
        if(!next){
          next=document.createElement('button');
          next.id='qa-review-next';
          next.className='sb-btn-next';
          next.textContent='Next →';
          next.onclick=function(){ window.goStep(5); };
          const placeholder=reviewNav.querySelector('div');
          if(placeholder) placeholder.replaceWith(next); else reviewNav.appendChild(next);
        }
      }
      const deliveryNav=deliveryStep.querySelector('.sb-nav-row');
      if(deliveryNav){
        const back=deliveryNav.querySelector('.sb-btn-back');
        if(back){ back.removeAttribute('onclick'); back.onclick=function(){ window.goStep(4); }; }
        const oldNext=document.getElementById('s4-next');
        if(oldNext) oldNext.style.display='none';
      }
    }

    function prepareCopy(){
      const dHeading=deliveryStep.querySelector('.sb-step-heading');
      const dSub=deliveryStep.querySelector('.sb-step-sub');
      if(dHeading) dHeading.innerHTML='Contact &amp; <em>Delivery Details</em>';
      if(dSub) dSub.textContent='Tell us where to deliver and how we can reach you. We’ll carry the supported details into secure checkout.';
      const labels=document.querySelectorAll('.sb-prog-label');
      if(labels[3]) labels[3].textContent='Review';
      if(labels[4]) labels[4].textContent='Delivery';
    }

    window.goStep=function(n){
      const logical=parseInt(n,10);
      let result;
      if(logical===4){ result=originalGoStep(5); polishReview(); setLogicalProgress(4); return result; }
      if(logical===5){ result=originalGoStep(4); restoreContact(); setLogicalProgress(5); return result; }
      result=originalGoStep(logical); setLogicalProgress(logical); return result;
    };

    if(typeof originalUpdateUpsellSummary==='function'){
      window.updateUpsellSummary=function(){ const result=originalUpdateUpsellSummary.apply(this,arguments); polishReview(); return result; };
    }

    window.qaFinishCheckout=function(){
      const contact=readContact();
      if(!validateContact(contact)) return;
      try{ localStorage.setItem('sk_contact',JSON.stringify(contact)); sessionStorage.setItem('sk_session_email',contact.email); }catch(e){}
      if(typeof originalTryGoStep5==='function') originalTryGoStep5();
      let delivery=null;
      try{ delivery=JSON.parse(localStorage.getItem('sk_delivery') || 'null'); }catch(e){}
      const current={zip:document.getElementById('d-zip') ? document.getElementById('d-zip').value.trim() : '',addr1:document.getElementById('d-addr1') ? document.getElementById('d-addr1').value.trim() : '',city:document.getElementById('d-city') ? document.getElementById('d-city').value.trim() : '',day:document.getElementById('d-day') ? document.getElementById('d-day').value : ''};
      if(!delivery || delivery.zip!==current.zip || delivery.addr1!==current.addr1 || delivery.city!==current.city || delivery.day!==current.day) return;
      installCheckoutHooks(contact);
      if(typeof originalStartPlan==='function') originalStartPlan();
    };

    buildContactFields();
    restoreContact();
    prepareCopy();
    hideReviewDelivery();
    moveFinalConfirmation();
    prepareNavigation();

    const estimate=document.getElementById('rv-estimated-total');
    if(estimate){ new MutationObserver(function(){ if(/box subtotal/i.test(estimate.textContent || '')) estimate.textContent=estimate.textContent.replace(/box subtotal/ig,'plan subtotal'); }).observe(estimate,{childList:true,characterData:true,subtree:true}); }

    window.addEventListener('popstate',function(){
      window.setTimeout(function(){
        const logical=logicalStepFromDom();
        if(logical===4) polishReview();
        if(logical===5) restoreContact();
        setLogicalProgress(logical);
      },0);
    });

    const initialLogical=logicalStepFromDom();
    if(initialLogical===4) polishReview();
    if(initialLogical===5) restoreContact();
    setLogicalProgress(initialLogical);
  });
})();
